<template>
  <div class="nav-container" :style="`height: ${height}px`">
    <div class="nav-content" :style="`width: ${width}px`">
      <template v-for="(item, index) in navList">
        <div class="nav-item" :key="`nav-${index}`"
          :class="[$route.path.toLowerCase() == `${item.path}` ? 'active' : '', item.path == active ? 'active' : '', item.path.indexOf($route.query.key) > -1 ? 'active' : '']"
           @click="routerPush(item)">
          <span class="nav-text">{{ item.name }}</span></div>
          <div v-if="index < navList.length - 1" class="split-line" :key="`line-${index}`"></div>
      </template>
    </div>
  </div>
</template>

<script>
import services from '../../config/services'
import { mapState } from 'vuex';
import utils from '../../config/utils';

export default {
  data() {
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      navList: []
    }
  },
  props: {
    active: {
      type: String
    },
    width: {
      type: String,
      default: "1400"
    },
    height: {
      type: String,
      default: "65"
    }

  },

  async mounted() {
    await this.getCategory()
  },
  methods: {
    routerPush(item) {
      if (item.needLogin && !this.loginUserInfo) { // 需要登录的页面且未登录，跳转到信息服务中心登录
        // return window.open(`${services.LOGIN_SERVER}/${this.school_code}/login?from=${window.location.href}`, "_self")
        return window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, "_self")
      }
      window.open(`/center${item.path}`, item._blank ? "_blank" : "_self")
    },
    // 获取课程分类
    async getCategory() {
      let that = this
      let navList = []
      navList = [{ name: "首页", path: `/${that.school_code}/hzvtc`, sort: 1, }]
      await services.getCategoryList({ root_id: 0, school_code: that.school_code }).then((res) => {
        if (res && res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.id == '469') {
              navList.push({ ...item, name: "杭职党校", path: `/${this.school_code}/hzvtc/hzdx`, sort: 1, })
            }
            if (item.id == '136') {
              navList.push({ ...item, name: "职业教育", path: `/${this.school_code}/hzvtc/profession`, sort: 2, })
            }
            if (item.id == '106') {
              navList.push({ ...item, name: "党性修养", path: `/${this.school_code}/hzvtc/culture`, sort: 3, })
            }
            if (item.id == '110') {
              navList.push({ ...item, name: "价值引领", path: `/${this.school_code}/hzvtc/value`, sort: 4, })
            }
            if (item.id == '121') {
              navList.push({ ...item, name: "家国情怀", path: `/${this.school_code}/hzvtc/feelings`, sort: 5, })
            }
            if (item.id == '195') {
              navList.push({ ...item, name: "特色文化", path: `/${this.school_code}/hzvtc/feature`, sort: 6, })
            }
            if (item.id == '152') {
              navList.push({ ...item, name: "健康教育", path: `/${this.school_code}/hzvtc/vita`, sort: 7, })
            }
            if (item.id == '136') {
              navList.push({ ...item, name: "专业群思政", path: `/${this.school_code}/hzvtc/zyqsz`, sort: 8, })
            }
          })
          navList.push({ name: "学习中心", path: `/${this.school_code}/user/myClass`, _blank: true, needLogin: true, sort: 9, },)
          this.navList = navList.sort((a, b) => a.sort - b.sort)
        }
      })
    },
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    }),
  },
}
</script>

<style lang="less" scoped>
.nav-container {
  width: 100%;
  height: 65px;
  background: #b61e2a;
  position: relative;
  z-index: 100;

  .nav-content {
    width: 1400px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-item {
      cursor: pointer;
      font-weight: bold;
      font-size: 18px;
      color: #F7B280;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    text-align: left;
      .nav-text {
        // display: inline-block;
        position: relative;
      }

      &.active {
        color: #FFFFFF;
        .nav-text::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -15px;
          transform: translate(-50%, 0);
          width: 24px;
          height: 4px;
          background: #FFFFFF;
        }
      }
    }
    .split-line {
      width: 1px;
      height: 19px;
      background-color: rgba(247, 178, 128, 0.24);
    }
  }
}
</style>